import { ethers } from 'ethers'

let _provider: ethers.JsonRpcProvider | null = null

export function getReadProvider(): ethers.JsonRpcProvider {
  if (!_provider) {
    const rpcUrl = import.meta.env.VITE_RPC_URL || 'https://rpc.sepolia.org'
    _provider = new ethers.JsonRpcProvider(rpcUrl)
  }
  return _provider
}

export function resetProvider(): void {
  _provider = null
}
